import { UserPostRequest, UserPostRequestSchema } from "callable-data-objects";
import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, FieldArray, FieldArrayRenderProps, Formik } from "formik";
import { useUser } from "Hooks/Endpoints";
import React from "react";
import {
  Breadcrumb,
  Menu,
  Card,
  Form,
  Segment,
  Header,
  Table,
  Button,
  Label,
} from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";

const OrganisationUserCreate = () => {
  const { createUser, save, uncreate, organisation, loading } = useUser();

  const connectedRole = (ref: DBReference, values: UserPostRequest) => {
    return values.groups.find((s) => s === ref.name) !== undefined;
  };

  const assignOrRevokeRole = (
    arrayHelpers: FieldArrayRenderProps,
    ref: DBReference,
    values: UserPostRequest
  ) => {
    connectedRole(ref, values)
      ? removeRole(arrayHelpers, ref, values)
      : pushRole(arrayHelpers, ref);
  };

  const pushRole = (arrayHelpers: FieldArrayRenderProps, ref: DBReference) => {
    console.log(ref);
    arrayHelpers.push(ref.name);
  };

  const removeRole = (
    arrayHelpers: FieldArrayRenderProps,
    ref: DBReference,
    values: UserPostRequest
  ) => {
    arrayHelpers.remove(values.groups.indexOf(ref.name));
  };

  const getColorRole = (
    ref: DBReference,
    values: UserPostRequest
  ): SemanticCOLORS => {
    return connectedRole(ref, values) ? "red" : "blue";
  };

  return (
    <div>
      <Menu stackable>
        <Menu.Item header>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => uncreate()}>
              Users
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>Create</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
      </Menu>
      <Card fluid>
        <Card.Content>
          <Formik
            initialValues={createUser}
            validationSchema={UserPostRequestSchema}
            onSubmit={(values, actions) => {
              save(values);
            }}
          >
            {(props) => (
              <Form onSubmit={props.handleSubmit}>
                {console.log(props)}
                <Segment color='blue'>
                  <Field
                    name='email'
                    label='Email Address'
                    component={CallableInput}
                  />

                  <Field
                    name='firstName'
                    label='First Name'
                    component={CallableInput}
                  />

                  <Field
                    name='lastName'
                    label='Last Name'
                    component={CallableInput}
                  />
                </Segment>

                <Segment color='purple'>
                  <Header as='h3'>Events Filter</Header>

                  <Field
                    name='recordingFilter.caller'
                    label='Calling Parties'
                    placeholder='077777777,01273652000,02033880500'
                    component={CallableInput}
                  />

                  <Field
                    name='recordingFilter.called'
                    label='Called Parties'
                    placeholder='077777777,01273652000,02033880500'
                    component={CallableInput}
                  />

                  <Field
                    name='recordingFilter.extension'
                    label='Extensions'
                    placeholder='2001,2002,600'
                    component={CallableInput}
                  />

                  <Field
                    name='recordingFilter.tag'
                    label='Tag'
                    placeholder='jobnumber=1234,name=james'
                    component={CallableInput}
                  />
                </Segment>

                <FieldArray
                  name='groups'
                  render={(arrayHelpers: FieldArrayRenderProps) => (
                    <Segment color='green'>
                      <Header as='h4'>Assigned Roles</Header>
                      {organisation.roles && (
                        <Table singleLine stackable padded striped>
                          <Table.Header>
                            <Table.HeaderCell></Table.HeaderCell>
                            <Table.HeaderCell>Role Name</Table.HeaderCell>
                            <Table.HeaderCell>Actions</Table.HeaderCell>
                          </Table.Header>
                          <Table.Body>
                            {organisation.roles.map((ref: DBReference) => (
                              <Table.Row key={ref.id}>
                                <Table.Cell width={1}>
                                  {connectedRole(ref, props.values) ? (
                                    <Label color='blue' ribbon>
                                      Assigned
                                    </Label>
                                  ) : (
                                    ""
                                  )}
                                </Table.Cell>
                                <Table.Cell width={14}>{ref.name}</Table.Cell>
                                <Table.Cell width={1}>
                                  <Button
                                    type='button'
                                    disabled={
                                      connectedRole(ref, props.values) &&
                                      props.values.groups?.length < 2
                                    }
                                    color={getColorRole(ref, props.values)}
                                    onClick={() =>
                                      assignOrRevokeRole(
                                        arrayHelpers,
                                        ref,
                                        props.values
                                      )
                                    }
                                  >
                                    {connectedRole(ref, props.values)
                                      ? "Revoke"
                                      : "Assign"}
                                  </Button>
                                </Table.Cell>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      )}
                    </Segment>
                  )}
                />

                <FormSubmit
                  name='Create User'
                  submitting={loading}
                  errors={props.errors}
                />
              </Form>
            )}
          </Formik>
        </Card.Content>
      </Card>
    </div>
  );
};

export default OrganisationUserCreate;
